import { DEFAULT_PROJETO } from 'src/components/projetos/constants'
import {
  ProjetoPersonalizadoHibridoLoadings,
  ProjetoPersonalizadoHibridoModals,
  ProjetoPersonalizadoHibridoValidations,
} from './personalizadoHibrido.types'


export const DEFAULT_PROJETO_PERSONALIZADO_HIBRIDO = {
  ...DEFAULT_PROJETO,
  tipo: 'personalizado',
  segmento: 'distribuicao_ongrid',
};

export const createDefaultProjetoPersonalizadoHibrido = () => JSON.parse(JSON.stringify(DEFAULT_PROJETO_PERSONALIZADO_HIBRIDO))

export const DEFAULT_PROJETO_PERSONALIZADO_HIBRIDO_VALIDATIONS: ProjetoPersonalizadoHibridoValidations = {
  gerador: false,
  estruturas: true,
  acessorios: true,
  finalizacao: true,
}

export const DEFAULT_PROJETO_PERSONALIZADO_HIBRIDO_LOADINGS: ProjetoPersonalizadoHibridoLoadings = {
  calcularProjeto: false,
  salvarProjeto: false,
  estruturas: false,
  acessorios: false,
}

export const DEFAULT_PROJETO_PERSONALIZADO_HIBRIDO_MODALS: ProjetoPersonalizadoHibridoModals = {
  detalhesComponenteId: null,
  faturamento: false,
  simulacaoFinanciamento: false,
}
